export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '用户',
    dataIndex: 'user_realname',
  },
  {
    title: '备注',
    dataIndex: 'action',
  },
  {
    title: '费用变化',
    dataIndex: 'score',
  },
  {
    title: '变更时间',
    dataIndex: 'create_time',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
